import { useNavigate } from 'react-router-dom';
import { createMFASetupPage } from '@puglieseweb/shared-react-auth';
import { useAuthContext } from '@/contexts/AuthContext';

const MFASetupPageInner = createMFASetupPage({
  appName: 'SystemDox',
  useAuthContext,
  // "Don't have an authenticator app?" opens this guide in a new tab.
  authenticatorHelpHref: 'https://www.systemdox.com/guides/authenticator-app',
});

export default function MFASetupPage() {
  const navigate = useNavigate();

  // MFA is opt-in for SystemDox self-serve: no gate forces it after signup
  // (that drove onboarding drop-off), so this page is reached voluntarily from
  // Settings ▸ Security. On success we return there so the user sees 2FA
  // enabled. There is deliberately no persistent client-settable skip flag
  // (the escape hatch removed by #1017); to leave without enrolling, go back.
  return (
    <MFASetupPageInner
      onSetupComplete={() => navigate('/settings/security', { replace: true })}
    />
  );
}
